import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode, useEffect, useMemo } from "react";
import createAppRouter from "./pages/router";
import { AuthProvider } from "./contexts/AuthProvider";
import { NuqsAdapter } from "nuqs/adapters/react";
import { RouterProvider } from "react-router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ToastProvider from "./components/common/toast";
import { useDynamicFavicon } from "./hooks/useDynamicFavicon";
import { useDynamicTitle } from "./hooks/useDynamicTitle";
import { renderMicky } from "./jojo";

declare global {
  interface Window {
    __version?: string;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

// Componente interno para usar hooks que requieren QueryClient
const AppContent = () => {
  useDynamicFavicon();
  useDynamicTitle();
  const commit = import.meta.env.VITE_APP_COMMIT;
  const tag = import.meta.env.VITE_APP_TAG;
  const message = `${commit}`.slice(0, 7) + (tag ? ` (${tag})` : "").trim();
  const router = useMemo(() => createAppRouter(queryClient), []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.__version = message;
    }
  }, [message]);

  return (
    <AuthProvider>
      <NuqsAdapter>
        <RouterProvider router={router} />
        <ToastProvider />
        <ReactQueryDevtools initialIsOpen={false} />
      </NuqsAdapter>
    </AuthProvider>
  );
};

const App = () => {
  console.log(renderMicky());
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppContent />
      </QueryClientProvider>
    </StrictMode>
  );
};

export default App;
